// extracted by mini-css-extract-plugin
export default {"wrapper":"ColorRectangle_wrapper__eGrWY","wrapper__blue":"ColorRectangle_wrapper__blue__aIaWK","wrapper__green":"ColorRectangle_wrapper__green__wB9k3"};